import { render, staticRenderFns } from "./ShopRedPacketRecord.vue?vue&type=template&id=5432626e&scoped=true&"
import script from "./ShopRedPacketRecord.vue?vue&type=script&lang=js&"
export * from "./ShopRedPacketRecord.vue?vue&type=script&lang=js&"
import style0 from "./ShopRedPacketRecord.vue?vue&type=style&index=0&id=5432626e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432626e",
  null
  
)

export default component.exports